import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { Text } from '../..'

export class TransitionBanner extends React.PureComponent {
  static Flows = Object.freeze({
    default: 'default',
    absolute: 'absolute'
  })

  static propTypes = {
    flow: PropTypes.oneOf(Object.values(TransitionBanner.Flows)),
    message: PropTypes.any,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    flow: TransitionBanner.Flows.default,
    showIcon: false
  }

  render() {
    const {
      flow,
      message,
      id,
      className,
      style,
      refProp,
      ...rest
    } = this.props

    const classes = getClasses(flow)

    return (
      <div
        id={id}
        className={cn(classes, className)}
        style={style}
        ref={refProp}
        {...rest}
      >
        <Text type={Text.Types.body}>{message}</Text>
      </div>
    )
  }
}

const getClasses = (flow) => {
  const classes = ['ui-banner', 'ui-banner--warning']

  switch (flow) {
    case TransitionBanner.Flows.absolute:
      classes.push('ui-banner--absolute')
      break
    default:
      break
  }

  return classes
}
